"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gowizardPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.gowizardPalette = {
    component: {
        answerSelectedColor: 'rgb(85, 191, 229)',
        answerUnselectedColor: 'rgb(148, 148, 148)',
        continueButtonColor: 'rgb(219, 0, 100)',
        continueButtonHoverColor: 'rgb(186, 45, 95)',
        backButtonColor: 'rgb(237, 237, 237)',
        backButtonHoverColor: 'rgb(223, 223, 223)',
        progressBarFilledColor: 'rgb(85, 191, 229)',
        progressBarUnfilledColor: 'rgb(247,247, 247)',
        scrollIndicatorColor: 'rgb(50, 50, 50)',
    },
    background: {
        answerBackgroundColor: 'rgb(248, 247, 252)',
        secondaryBackgroundColor: 'rgb(209, 236, 250)',
        widgetBackgroundColor: 'rgb(253, 253, 253)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(79, 79, 79)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var gowizardTheme = (0, themeCreator_1.default)(exports.gowizardPalette);
exports.default = gowizardTheme;
//# sourceMappingURL=gowizardTheme.js.map